export default __webpack_public_path__ + "static/contact-fb04464fe760be65b352a1a00c08abb2.png";